import { render, staticRenderFns } from "./Edit-Txt.vue?vue&type=template&id=d8668468&"
import script from "./Edit-Txt.vue?vue&type=script&lang=js&"
export * from "./Edit-Txt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports